export default "__VITE_ASSET__CfVYLz0D__"